import { createAction } from "@reduxjs/toolkit";
import axios from 'apis';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

const attributes = ['id', 'name', 'display_name', 'address', 'slots_count', 'synchronized', 'updated_at'];

export const getLocations = asyncThunkWrapper({ 
  model: 'locations', 
  action: 'getLocations', 
  func: async ({ offset = 0, query = null }) => {
    const params = { limit: 25, offset, orders: { updated_at: 'desc' }, attributes, ...(query && { query }) };
    const response = await axios.get('/locations', { params });

    return response.data;
  } 
});
export const getLocation = asyncThunkWrapper({ 
  model: 'locations', 
  action: 'getLocation', 
  func: async (id) => {
    const params = { attributes };
    const response = await axios.get(`/locations/${id}`, { params });

    return response.data;
  } 
});
export const createLocation = asyncThunkWrapper({ 
  model: 'locations', 
  action: 'createLocation', 
  func: async (location) => {
    const response = await axios.post('/locations', { location, attributes });

    return response.data;
  } 
});
export const updateLocation = asyncThunkWrapper({ 
  model: 'locations', 
  action: 'updateLocation', 
  func: async ({ id, ...fields }) => {
    const response = await axios.patch(`/locations/${id}`, { location: { ...fields } });

    return { status: response.status, location: { id, ...fields } };
  } 
});
export const deleteLocation = asyncThunkWrapper({ 
  model: 'locations', 
  action: 'deleteLocation', 
  func: async (id) => {
    const response = await axios.delete(`/locations/${id}`);

    return { status: response.status, id };
  } 
});
export const clearLocalLocations = createAction('locations/clearLocalLocations');
export const clearLocalActiveLocation = createAction('locations/clearLocalActiveLocation');